import { render, staticRenderFns } from "./WidgetsBrand.vue?vue&type=template&id=039bc7e9&scoped=true&"
import script from "./WidgetsBrand.vue?vue&type=script&lang=js&"
export * from "./WidgetsBrand.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsBrand.vue?vue&type=style&index=0&id=039bc7e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039bc7e9",
  null
  
)

export default component.exports